import React from 'react';
import { WIDGET_ICON_MAP } from '../../../widgetIconMap';
import { formatShabbatTimeRule } from '../../shabbatZmanUtils';
import LeyningDisplay from '../../../shared/LeyningDisplay';

const Classic = ({ shabbat, processedCustomTimes, drashaText, loading, error, title = 'זמני שבת', showTitle = true, entryIcon = 'ShabbatCandles', exitIcon = 'MoonStar', dayEntryTime, dayExitTime, bgColor, showTimeRule = false, showEntryExit = true, shabbatLeyning, showLeyning, showHaftarah, leyningDisplayMode }) => {
  const bg = bgColor || '#ffffff';
  const EntryIcon = WIDGET_ICON_MAP[entryIcon] || WIDGET_ICON_MAP['ShabbatCandles'];
  const ExitIcon  = WIDGET_ICON_MAP[exitIcon]  || WIDGET_ICON_MAP['MoonStar'];

  const timeToMinutes = (t) => {
    if (!t || t === '--:--') return -1;
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  };

  if (loading) return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: NAVY }}>טוען זמני שבת...</span></div>;
  if (error)   return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: '#c0392b' }}>{error}</span></div>;
  if (!shabbat) return <div style={{ ...S.wrap, backgroundColor: bg, justifyContent: 'center', alignItems: 'center' }}><span style={{ color: NAVY }}>אין נתוני שבת</span></div>;

  const parasha = shabbat.meta?.parsha || shabbat.parsha || 'פרשת השבוע';
  const entry   = dayEntryTime || shabbat.meta?.candleLighting || shabbat.friday?.candleLighting || '--:--';
  const exit    = dayExitTime  || shabbat.meta?.havdalah      || shabbat.shabbat?.havdalah      || '--:--';

  const fridayTimes  = (processedCustomTimes || []).filter(ct => (ct.day || 'friday') === 'friday').sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time));
  const shabbatTimes = (processedCustomTimes || []).filter(ct => ct.day === 'shabbat').sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time));
  const allCustom    = [...fridayTimes, ...shabbatTimes];

  return (
    <div style={{ ...S.wrap, backgroundColor: bg }} dir="rtl">

      {/* פס עליון נייבי */}
      <div style={S.topBar}>
        <EntryIcon style={{ width: '18px', height: '18px', color: GOLD }} />
        {showTitle && <span style={S.topBarTitle}>{title}</span>}
        <ExitIcon style={{ width: '18px', height: '18px', color: GOLD }} />
      </div>

      <div style={S.body}>

        {/* פרשה עם קישוטים */}
        <div style={S.parshaSection}>
          <div style={S.ornamentRow}>
            <span style={S.orn}>✦</span>
            <span style={S.ornLine} />
            <span style={S.orn}>✦</span>
          </div>
          {shabbat.meta?.parshaShowPrefix !== false && <div style={S.parshaLabel}>פרשת</div>}
          <div style={S.parshaName}>{parasha}</div>
          {shabbat.meta?.parshaSubtitle && <div style={S.parshaSubtitle}>{shabbat.meta.parshaSubtitle}</div>}
          <div style={S.ornamentRow}>
            <span style={S.orn}>✦</span>
            <span style={S.ornLine} />
            <span style={S.orn}>✦</span>
          </div>
        </div>

        {/* קריאה */}
        {(showLeyning || showHaftarah) && shabbatLeyning && (
          <div style={{
            padding: '10px 14px',
            marginBottom: '18px',
            border: `1px solid ${BORDER}`,
            borderRadius: '8px',
            backgroundColor: '#f9f7f2',
          }}>
            <LeyningDisplay
              leyning={shabbatLeyning}
              mode={leyningDisplayMode}
              showHaftarah={showHaftarah}
              showMaftir={leyningDisplayMode === 'full'}
              compact={false}
            />
          </div>
        )}

        {/* זמני כניסה ויציאה — שני עמודות */}
        {showEntryExit && (
          <div style={S.timesRow}>
            <div style={S.timeBlock}>
              <div style={S.timeIconCircle}>
                <EntryIcon style={{ width: '20px', height: '20px', color: '#fff' }} />
              </div>
              <div style={S.timeBlockLabel}>כניסת שבת</div>
              <div style={S.timeBlockValue}>{entry}</div>
            </div>

            <div style={S.vSeparator}>
              <div style={S.vSepLine} />
              <span style={{ color: GOLD, fontSize: '16px' }}>✦</span>
              <div style={S.vSepLine} />
            </div>

            <div style={S.timeBlock}>
              <div style={{ ...S.timeIconCircle, backgroundColor: NAVY }}>
                <ExitIcon style={{ width: '20px', height: '20px', color: GOLD }} />
              </div>
              <div style={S.timeBlockLabel}>צאת שבת</div>
              <div style={S.timeBlockValue}>{exit}</div>
            </div>
          </div>
        )}

        {/* דרשה */}
        {drashaText && (
          <div style={S.drashaSection}>
            <div style={S.drashaBar} />
            <div style={S.drashaText}>{drashaText}</div>
            <div style={S.drashaBar} />
          </div>
        )}

        {/* זמנים מותאמים */}
        {allCustom.length > 0 && (
          <div style={S.customSection}>
            <div style={S.customHeader}>
              <span style={S.orn}>✦</span>
              <span style={S.customHeaderText}>זמנים נוספים</span>
              <span style={S.orn}>✦</span>
            </div>
            {allCustom.map((ct, i) => (
              <div key={i} style={{ ...S.customRow, borderBottom: i < allCustom.length - 1 ? `1px solid ${BORDER}` : 'none' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                  <span style={S.customLabel}>{ct.label}</span>
                  {showTimeRule && formatShabbatTimeRule(ct) && (
                    <span style={{ fontSize: '10px', color: S.customLabel.color, opacity: 0.55, lineHeight: 1 }}>{formatShabbatTimeRule(ct)}</span>
                  )}
                </div>
                <span style={S.customTime}>{ct.time}</span>
              </div>
            ))}
          </div>
        )}

      </div>

    </div>
  );
};

const NAVY   = '#1e3a5f';
const GOLD   = '#9a7209';
const BORDER = '#e8e0d0';

const S = {
  wrap: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  topBar: {
    backgroundColor: NAVY,
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    flexShrink: 0,
  },
  topBarTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#fff',
    letterSpacing: '0.1em',
  },
  body: {
    flex: 1,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    overflowY: 'auto',
  },
  parshaSection: {
    textAlign: 'center',
    marginBottom: '18px',
  },
  ornamentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '8px 0',
  },
  orn: {
    color: GOLD,
    fontSize: '11px',
    flexShrink: 0,
  },
  ornLine: {
    flex: 1,
    height: '1px',
    backgroundColor: GOLD,
    opacity: 0.4,
    display: 'block',
  },
  parshaLabel: {
    fontSize: '12px',
    color: '#9a8f7a',
    letterSpacing: '0.12em',
    marginBottom: '3px',
  },
  parshaName: {
    fontSize: '36px',
    fontWeight: '800',
    color: NAVY,
    lineHeight: 1.15,
    marginBottom: '4px',
  },
  parshaSubtitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: NAVY,
    opacity: 0.75,
    marginTop: '2px',
    marginBottom: '2px',
  },
  timesRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0',
    marginBottom: '18px',
    border: `1px solid ${BORDER}`,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  timeBlock: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 12px',
    gap: '8px',
  },
  timeIconCircle: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    backgroundColor: GOLD,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  timeBlockLabel: {
    fontSize: '13px',
    color: '#7a8a9a',
    fontWeight: '600',
    letterSpacing: '0.04em',
  },
  timeBlockValue: {
    fontSize: '38px',
    fontWeight: '800',
    color: NAVY,
    direction: 'ltr',
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
  },
  vSeparator: {
    width: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    flexShrink: 0,
    padding: '16px 0',
    backgroundColor: '#f9f7f2',
  },
  vSepLine: {
    width: '1px',
    flex: 1,
    backgroundColor: GOLD,
    opacity: 0.4,
  },
  drashaSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  },
  drashaBar: {
    width: '4px',
    flexShrink: 0,
    alignSelf: 'stretch',
    backgroundColor: GOLD,
    borderRadius: '2px',
    opacity: 0.6,
  },
  drashaText: {
    flex: 1,
    fontSize: '15px',
    color: NAVY,
    fontStyle: 'italic',
    fontWeight: '600',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
  },
  customSection: {
    border: `1px solid ${BORDER}`,
    borderRadius: '8px',
    overflow: 'hidden',
  },
  customHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 14px',
    backgroundColor: '#f5f0e8',
    borderBottom: `1px solid ${BORDER}`,
  },
  customHeaderText: {
    flex: 1,
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '700',
    color: NAVY,
    letterSpacing: '0.08em',
  },
  customRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '9px 14px',
  },
  customLabel: {
    fontSize: '14px',
    color: '#5a6978',
  },
  customTime: {
    fontSize: '17px',
    fontWeight: '700',
    color: NAVY,
    direction: 'ltr',
  },
};

export default Classic;
